const classes = Object.freeze({
    root: 'll-select ll-standard-select',
    select: 'll-select_input-base',
    icon: 'll-select__svg-icon'
});

export {
    classes,
};